import { withChartLayout } from 'components/common';
import GlasgowComaScale from 'components/features/chart/special-charts/glasgow-coma-scale/GlasgowComaScale';

const GlasgowComaScalePage = withChartLayout('Glasgow Coma Scale')(GlasgowComaScale);
export default GlasgowComaScalePage;
